import styled from 'styled-components';
import { Link } from 'react-router-dom';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const MainContainer = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ToTopButton = styled(Link)`
  width: 200px;
  height: 50px;
  text-decoration: none;
  cursor: pointer;
  border: 1px solid ${ColorSF2.mediumGray}};
  border-radius: 5px;
  padding: 5px;
  margin: 10px;
  background-color: ${ColorSF2.white};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${ColorSF2.alertRed};
`;
